import { render, staticRenderFns } from "./Files.html?vue&type=template&id=7785645d&"
import script from "./Files.js?vue&type=script&lang=js&"
export * from "./Files.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports